import { Option } from "../../common/index"

type RedirectViewModel = {
    Successed:boolean,
    RedirectUrl:string,
    IsAutoRedirect:boolean,
    OnlyThirdPartyLogin:boolean
}
/**
 * 登录模式
 * @param LoginForm 账户密码登录
 * @param ThirdPartyLogin 第三方登录
 * @param PhoneLogin 手机号登录
 */
enum LoginMode {
    /**
     * 账户密码登录
     */
    LoginForm,
    /**
     * 第三方登录
     */
    ThirdPartyLogin,
    /**
     * 手机号登录
     */
    PhoneLogin
}
/**
 * 登录参数
 */
type LoginModel = {
    /**
     * 用户名
     */
    userName:string,
    /**
     * 用户密码
     */
    userPassword:string,
    /**
     * 是否记住密码
     */
    rememberMe:boolean
}

type UserInfo = {
    IsAuthenticated:boolean
    UserName:string
    NickName:string,
    Depart:Array<number>,
    Role:Array<number>,
    DepartInfos:Array<Option>,
    Roles:Array<Option>,
    Leaders:Array<UserInfo>
}

type ThirdPartyLoginSetting = {
    AutoThirdPartyLogin:string,
    OnlyThirdPartyLogin:string
}

export {
    RedirectViewModel,
    LoginMode,
    LoginModel,
    UserInfo,
    ThirdPartyLoginSetting
}